import { createFileRoute } from '@tanstack/react-router';
import { DiscoverySetup } from '@/components/discovery/setup/setup-screen';

/** Discovery -> Set up (T-0185): first run only; after the start it redirects to Overview. */
export const Route = createFileRoute('/engagements/$engagementId/discovery/setup')({
  component: function SetupRoute() {
    const { engagementId } = Route.useParams();
    return <DiscoverySetup engagementId={engagementId} />;
  },
});
